export { default } from './InteractiveIconHeader';
